import React, { useEffect } from "react";
import { createGlobalStyle } from "styled-components";
var StyledStopPropagationPageScroll = createGlobalStyle(["html,body{overflow:hidden;}"]);
function stopPropagation(event) {
  event.stopPropagation();
}
function StopPropagationPageScroll() {
  useEffect(function () {
    window.addEventListener("touchmove", stopPropagation);
    return function () {
      window.removeEventListener("touchmove", stopPropagation);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledStopPropagationPageScroll, null);
}
export default StopPropagationPageScroll;